/** D6 values below this threshold display as $0.00 — treat as neutral. */
export const PNL_DUST_D6 = 5_000;

export function pnlColorClass(value: number): string {
  if (Math.abs(value) < PNL_DUST_D6) return 'text-foreground-disabled';
  if (value > 0) return 'text-data-profit';
  return 'text-data-loss';
}

export function pnlPillClass(value: number): string {
  if (Math.abs(value) < PNL_DUST_D6) return 'bg-background-tertiary text-foreground-secondary';
  if (value > 0) return 'bg-green-500/10 text-green-500';
  if (value < 0) return 'bg-red-500/10 text-red-500';
  return 'bg-background-tertiary text-foreground-secondary';
}

export function pnlBarColor(value: number): string {
  if (Math.abs(value) < PNL_DUST_D6) return 'bg-background-tertiary';
  if (value > 0) return 'bg-green-500';
  return 'bg-red-500';
}

export function truncateAddress(address: string): string {
  if (address.length <= 8) return address;
  return `${address.slice(0, 4)}...${address.slice(-4)}`;
}
